// Generated from configurators/shared/blubat/ctt-blubat-catalog.js.
// Do not edit this copy directly; run scripts/sync_blubat_catalog.py.

(function (global) {
  const catalogVersion = '2026-07-29';
  const skuSchemaVersion = 4;
  const buildCodeReservedSuffix = '000000000';

  const antennaLengths = [
    { label: '1/4 wave - standard (31.25mm)', value: 31.25, variantKey: 'wire-quarter', tier: 'W14' },
    { label: '1/2 wave (62.5mm)', value: 62.5, variantKey: 'wire-half', tier: 'W12' }
  ];

  const antennaWeights = {
    'coated-steel': {
      '10': { '31.25': 0.008, '62.5': 0.015 }
    },
    nitinol: {
      '1×7 (0.2mm)': { '31.25': 0.008, '62.5': 0.014 },
      '1×7 (0.4mm)': { '31.25': 0.029, '62.5': 0.048 },
      '1×7 (0.6mm)': { '31.25': 0.060, '62.5': 0.110 },
      '1×7 (0.8mm)': { '31.25': 0.0935, '62.5': 0.17165 }
    }
  };

  const antennaMaterials = [
    {
      value: 'coated-steel',
      label: 'Nylon-coated Steel',
      adminHelper: 'Coated, corrosion resistant'
    },
    {
      value: 'nitinol',
      label: 'Nitinol',
      adminHelper: 'Superelastic, high durability, excellent flexibility'
    }
  ];

  const batteries = [
    { buildCode: '0', partId: '-SR416SW', name: 'SR416SW', consumerAlias: '337', capacity: 7.5, displayCapacity: 7.5, coatingCalibrationCapacity: 8.3, weight: 0.13, sutureCaseWeight: 0.14, default: true },
    { buildCode: '1', partId: '-SR421SW', name: 'SR421SW', consumerAlias: '348', capacity: 12, displayCapacity: 12, coatingCalibrationCapacity: 12, weight: 0.153, sutureCaseWeight: 0.14 },
    { buildCode: '2', partId: '-SR521SW', name: 'SR521SW', consumerAlias: '379', capacity: 16, displayCapacity: 16, coatingCalibrationCapacity: 16, weight: 0.235, sutureCaseWeight: 0.15 },
    { buildCode: '3', partId: '-SR527SW', name: 'SR527SW', consumerAlias: '319', capacity: 22, displayCapacity: 22, coatingCalibrationCapacity: 21, weight: 0.286, sutureCaseWeight: 0.15 },
    { buildCode: '4', partId: '-SR716SW', name: 'SR716SW', consumerAlias: '315', capacity: 21, displayCapacity: 21, coatingCalibrationCapacity: 23, weight: 0.3, sutureCaseWeight: 0.35 },
    { buildCode: '5', partId: '-SR626SW', name: 'SR626SW', consumerAlias: '377', capacity: 28, displayCapacity: 28, coatingCalibrationCapacity: 28, weight: 0.38, sutureCaseWeight: 0.15 },
    { buildCode: '6', partId: '-SR726SW', name: 'SR726SW', consumerAlias: '397', capacity: 34, displayCapacity: 34, coatingCalibrationCapacity: 33, weight: 0.54, sutureCaseWeight: 0.35 },
    { buildCode: '7', partId: '-SR920SW', name: 'SR920SW', consumerAlias: '371', capacity: 46, displayCapacity: 46, coatingCalibrationCapacity: 39, weight: 0.593, sutureCaseWeight: 0.35 },
    { buildCode: '8', partId: '-SR41SW', name: 'SR41SW', consumerAlias: '384', capacity: 45, displayCapacity: 45, coatingCalibrationCapacity: 45, weight: 0.67, sutureCaseWeight: 0.35 },
    { buildCode: '9', partId: '-SR927SW', name: 'SR927SW', consumerAlias: '395', capacity: 53, displayCapacity: 53, coatingCalibrationCapacity: 55, weight: 0.75, sutureCaseWeight: 0.35 }
  ];

  const antennaBuildCodes = {
    pcb: 'A',
    chip: 'B',
    'wire|nitinol|1×7 (0.2mm)|31.25': 'C',
    'wire|nitinol|1×7 (0.2mm)|62.5': 'D',
    'wire|nitinol|1×7 (0.4mm)|31.25': 'E',
    'wire|nitinol|1×7 (0.4mm)|62.5': 'F',
    'wire|nitinol|1×7 (0.6mm)|31.25': 'G',
    'wire|nitinol|1×7 (0.6mm)|62.5': 'H',
    'wire|coated-steel|10|31.25': 'I',
    'wire|coated-steel|10|62.5': 'J',
    'wire|nitinol|1×7 (0.8mm)|31.25': 'K',
    'wire|nitinol|1×7 (0.8mm)|62.5': 'L'
  };

  const beepBuildCodes = {
    3: '0',
    5: '1',
    10: '2',
    20: '3',
    30: '4',
    60: '5'
  };

  function getAntennaTier(antennaType, wireLength) {
    if (antennaType === 'pcb') return 'PCB';
    if (antennaType === 'chip') return 'CHIP';
    if (antennaType === 'wire' && Number(wireLength) === 31.25) return 'W14';
    if (antennaType === 'wire' && Number(wireLength) === 62.5) return 'W12';
    throw new Error(`Unsupported BlūBat antenna selection: ${antennaType}/${wireLength}`);
  }

  function getAntennaBuildCode({ antennaType, wireMaterial, wireGauge, wireLength }) {
    const key = antennaType === 'wire'
      ? `wire|${wireMaterial}|${wireGauge}|${Number(wireLength)}`
      : antennaType;
    const code = antennaBuildCodes[key];

    if (!code) {
      throw new Error(`Unsupported BlūBat antenna build selection: ${key}`);
    }

    return code;
  }

  function createBuildIdentifiers({
    mounting,
    transmission,
    antennaType,
    wireMaterial,
    wireGauge,
    wireLength,
    batteryBuildCode,
    beepInterval
  }) {
    const mountCode = { glue: 'GL', case: 'SC' }[mounting];
    const transmissionCode = { single: 'S', dual: 'E' }[transmission];
    const batteryCode = String(batteryBuildCode);
    const beepCode = beepBuildCodes[Number(beepInterval)];

    if (!mountCode) throw new Error(`Unsupported BlūBat mounting: ${mounting}`);
    if (!transmissionCode) throw new Error(`Unsupported BlūBat transmission: ${transmission}`);
    if (!/^[0-9]$/.test(batteryCode)) {
      throw new Error(`Unsupported BlūBat battery build code: ${batteryBuildCode}`);
    }
    if (beepCode === undefined) {
      throw new Error(`Unsupported BlūBat beep interval: ${beepInterval}`);
    }

    const antennaCode = getAntennaBuildCode({
      antennaType,
      wireMaterial,
      wireGauge,
      wireLength
    });
    const antennaTier = getAntennaTier(antennaType, wireLength);
    const variantSku = `BBAT-${mountCode}-${transmissionCode}-${antennaTier}`;
    const buildCode = `${antennaCode}${batteryCode}${beepCode}${buildCodeReservedSuffix}`;

    return {
      schemaVersion: skuSchemaVersion,
      variantSku,
      buildCode,
      buildSku: `${variantSku}-${buildCode}`
    };
  }

  const pricing = {
    BASE: 200,
    CHIP_ANTENNA: 25,
    WIRE_QUARTER_WAVE: 20,
    WIRE_HALF_WAVE: 25,
    DUAL_TRANSMISSION: 25,
    CASE: 75
  };

  const antennaPriceByVariantKey = {
    pcb: 0,
    chip: pricing.CHIP_ANTENNA,
    'wire-quarter': pricing.WIRE_QUARTER_WAVE,
    'wire-half': pricing.WIRE_HALF_WAVE
  };

  const variantMapFull = {
    // Legacy C12 "Chip or Wire 1/2λ" variants remain in Shopify for historical
    // orders, but new checkouts must route to explicit W12 or C variants.
    'glue-single-pcb': 52990703009952,
    'glue-single-wire-quarter': 52990974197920,
    'glue-single-wire-half': 58109514514592,
    'glue-single-chip': 58109514547360,
    'glue-dual-pcb': 52990974296224,
    'glue-dual-wire-quarter': 52990974328992,
    'glue-dual-wire-half': 58109514580128,
    'glue-dual-chip': 58109514612896,
    'case-single-pcb': 52990974427296,
    'case-single-wire-quarter': 52990974460064,
    'case-single-wire-half': 58109514645664,
    'case-single-chip': 58109514678432,
    'case-dual-pcb': 52990974558368,
    'case-dual-wire-quarter': 52990974591136,
    'case-dual-wire-half': 58109514711200,
    'case-dual-chip': 58109514743968
  };

  const services = {
    motusRegistration: {
      variantId: 44905391194272,
      price: 20
    },
    bluPlusData: {
      variantId: 52648383512736,
      price: 2,
      daysPerCredit: 30
    }
  };

  function recommendedDataCredits(lifespanDays) {
    const days = Number(lifespanDays);
    if (!Number.isFinite(days) || days <= 0) return 0;
    return Math.ceil(days / services.bluPlusData.daysPerCredit);
  }

  const common = {
    PCB_WEIGHT: 0.038,
    CHIP_ANTENNA_WEIGHT: 0.022,
    TRANSMISSION_CURRENT: 19,
    SLEEP_CURRENT: 0.00085,
    TRANSMIT_SECONDS: 0.001,
    EFFICIENCY: 0.95,
    COATING: {
      // These endpoints are the established physical-weight calibration
      // scale, not authoritative electrical capacities. Individual batteries
      // retain a coatingCalibrationCapacity so correcting mAh values changes
      // life estimates without silently changing calibrated build weights.
      MIN_CAPACITY: 8.3,
      MAX_CAPACITY: 55,
      MIN_WEIGHT: 0.042,
      MAX_WEIGHT: 0.1154,
      SUTURE_CASE_EXTRA_WEIGHT: 0.013,
      SUTURE_CASE_EXTRA_MIN_CAPACITY: 21,
      SUTURE_CASE_EXTRA_MAX_WEIGHT: 0.1176,
      SUTURE_CASE_CHIP_EPOXY_FILL_MIN_CAPACITY: 21,
      SUTURE_CASE_CHIP_EPOXY_FILL_MAX_WEIGHT: 0.407
    }
  };

  const customerConfig = {
    ...common,
    ANTENNA_MATERIALS: antennaMaterials,
    BATTERIES: batteries,
    ANTENNA_LENGTHS: antennaLengths,
    BEEP_INTERVALS: [3, 5, 10, 20, 30, 60],
    DEFAULT_BEEP_INTERVAL: 10,
    PRICING: pricing,
    ANTENNA_PRICE_BY_VARIANT_KEY: antennaPriceByVariantKey,
    ANTENNA_WEIGHTS: antennaWeights
  };

  const catalog = {
    version: catalogVersion,
    skuSchemaVersion,
    createBuildIdentifiers,
    antennaBuildCodes,
    beepBuildCodes,
    antennaMaterials,
    antennaLengths,
    antennaWeights,
    batteries,
    pricing,
    services,
    recommendedDataCredits,
    antennaPriceByVariantKey,
    variantMapFull,
    customerConfig,
    shopifyConfig: {
      ENABLED: true,
      VARIANT_STRATEGY: 'full',
      PRODUCT_VARIANT_ID: 52990703009952,
      VARIANT_MAP_BY_MOUNTING: {
        'glue-single': 52990703009952,
        'glue-dual': 52990974296224,
        'case-single': 52990974427296,
        'case-dual': 52990974558368
      },
      VARIANT_MAP_FULL: variantMapFull,
      CUSTOM_VARIANT_SELECTOR: null,
      LINE_ITEM_PROPERTIES: true,
      PRICE_STRATEGY: 'variant'
    },
    adminConfig: {
      basePrice: pricing.BASE,
      ...common,
      batteries,
      antennaMaterials,
      antennaLengths,
      antennaWeights,
      antennaPriceByVariantKey,
      services,
      recommendedDataCredits,
      variantMap: variantMapFull,
      pricing: {
        chipAntenna: pricing.CHIP_ANTENNA,
        wireQuarter: pricing.WIRE_QUARTER_WAVE,
        wireHalf: pricing.WIRE_HALF_WAVE,
        dualTransmission: pricing.DUAL_TRANSMISSION,
        case: pricing.CASE
      }
    }
  };

  global.CTT_BLUBAT_CATALOG = catalog;
})(typeof window !== 'undefined' ? window : globalThis);
